import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui-kit/button';
import { MutateTemplateForm } from '../../components/mutate-template-form/mutate-template-form';
import { useGetTemplate } from '../../hooks/use-templates';
import { getTemplateSessionGuidance } from '../../utils/template-api-errors';

export const EditTemplatePage = () => {
  const navigate = useNavigate();
  const { templateId = '' } = useParams<{ templateId: string }>();
  const { data: template, isLoading, isError, error } = useGetTemplate(templateId);

  if (isLoading) {
    return (
      <div className="rounded-lg border bg-muted/20 px-4 py-10 text-center text-sm text-muted-foreground">
        Loading template...
      </div>
    );
  }

  if (isError || !template) {
    return (
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 py-10">
        <div className="rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-6 text-sm text-destructive">
          {getTemplateSessionGuidance(error) ??
            'This template is no longer available — it may have been deleted, or the link is out of date.'}
        </div>
        <Button type="button" variant="outline" onClick={() => navigate('/templates')}>
          Back to templates
        </Button>
      </div>
    );
  }

  return <MutateTemplateForm mode="edit" template={template} />;
};
